import { render, staticRenderFns } from "./WellnessActivitiesDialog.vue?vue&type=template&id=020169d7&scoped=true"
import script from "./WellnessActivitiesDialog.vue?vue&type=script&lang=js"
export * from "./WellnessActivitiesDialog.vue?vue&type=script&lang=js"
import style0 from "./WellnessActivitiesDialog.vue?vue&type=style&index=0&id=020169d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020169d7",
  null
  
)

export default component.exports